import { Route, Routes, Link } from 'react-router-dom';
import { Layout, Typography, Space } from 'antd';

import {
  Navbar,
  Home,
  Exchanges,
  Cryptocurrencies,
  CryptoDetails,
  News
} from './components';

import './app.css';

const App = () => {
  return (
    <div className='app'>
      <div className='navbar'>
        <Navbar />
      </div>
      <div className='main'>
        <Layout>
          <div className='routes'>
            <Routes>
              <Route exact path='/' element={<Home />} />
              <Route exact path='/exchanges' element={<Exchanges />} />
              <Route
                exact
                path='/cryptocurrencies'
                element={<Cryptocurrencies />}
              />
              <Route exact path='/crypto/:coinId' element={<CryptoDetails />} />
              <Route exact path='/news' element={<News />} />
            </Routes>
          </div>
        </Layout>
        <div className='footer'>
          <Typography.Title
            level={5}
            style={{ color: 'white', textAlign: 'center' }}
          >
            Cryptomania <br />
            All rights reserved
          </Typography.Title>
          <Space>
            <Link to='/'>Home</Link>
            <Link to='/exchanges'>Exchanges</Link>
            <Link to='/news'>News</Link>

            <a
              href='https://www.youtube.com/watch?v=GDa8kZLNhJ4&t=8920s'
              target='_blank'
            >
              'Website built from Javascript Mastery Tutorial'
            </a>
          </Space>
        </div>
      </div>
    </div>
  );
};

export default App;
